import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { IndividualService } from "src/core/services/individual.service";
import { LocalStorageService } from "src/core/services/local-storage.service";
import { PrescriptionService } from "src/core/services/prescription.service";
import { CompanyService } from "src/core/services/company.service";
import { Company } from "src/interfaces/company";
import { Individual } from "src/interfaces/individual";

@Injectable({
    providedIn: 'root'
})
export class IndividualResolver  {

    constructor(
        private _individualService: IndividualService,
        private _companyService: CompanyService,
    ) { }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<{
       individual: Individual | null,
       company: Company | null
    }> {

        let company: Company | null = null;
        let individual: Individual | null = null;

        individual = await this
            ._individualService
            .getIndividual(
                parseInt(route.params['id'])
            );

        if (individual && individual.distributor_id && !individual.distributor) {
            const d = await this._companyService.getCompany(individual.distributor_id);
            if (d) individual = { ...individual, distributor: d };
        }
        
        if(individual && individual.company_id) 
            company = await this._individualService.getCompany(individual.company_id);
        
        return {
            individual,
            company
        }
        
    }
}

@Injectable({
    providedIn: 'root'
})
export class IndividualsResolver  {
    limit: number = 10;
    page: number = 1;
    constructor(
        private _clientService: IndividualService,
        private localStorageService: LocalStorageService
    ) {
        const limit = this.localStorageService.get('INDIVIDUALS', 'LIMIT');
        if (limit) {
            this.limit = parseInt(limit);
        }
    }

    async resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Promise<
    {
        individuals: Individual[],
        pageNumber: number
    }
    > {

        const page = this.localStorageService.get('INDIVIDUALS', 'PAGE');
        if (page) {
            this.page = parseInt(page);
        } else {
            this.page = 1;
        }
        
        const individuals = await  this
            ._clientService
            .getIndividuals(this.page, this.limit, "");
        return {
            individuals,
            pageNumber: this.page
        }
    }
}